module.exports = __webpack_public_path__ + "img/calendar2-x.b51decb1.svg";